import { DATE_FULL_FORMAT } from '../../../../../constants/date'
import { NUMBER_SIZE } from '../../../../../constants/size'
import { getFileValueSize } from '../../../../File'
import { FileIconPreview } from '../../../../FileIcon'
import { toListingUserCellValue } from '../../../../RentalPortalListing'
import {
  TableCellBase,
  TableCellText,
  TableDateCell,
  TableEmptyCell,
  TableTextCell,
  TableUserCell,
} from '../../../../Table'
import { ViewingDocumentColumnName } from '../RentalPortalViewingProfileDocuments.constants'

export function renderViewingProfileDocumentsCell({
  item,
  name,
  nameCellClassName,
  ...restProps
}) {
  const { [name]: value } = item

  switch (name) {
    case ViewingDocumentColumnName.Name:
      return (
        <TableCellBase {...restProps} className={nameCellClassName}>
          <FileIconPreview file={item} size={NUMBER_SIZE.size24} />
          <TableCellText value={value} />
        </TableCellBase>
      )

    case ViewingDocumentColumnName.Size:
      return (
        <TableTextCell
          {...restProps}
          value={value ? getFileValueSize({ value }) : null}
        />
      )

    case ViewingDocumentColumnName.Uploaded:
      return (
        <TableDateCell
          {...restProps}
          dateFormat={DATE_FULL_FORMAT}
          value={value}
        />
      )

    case ViewingDocumentColumnName.UploadedBy:
      return (
        <TableUserCell {...restProps} value={toListingUserCellValue(value)} />
      )

    default:
      return <TableEmptyCell {...restProps} />
  }
}
